export default __webpack_public_path__ + "static/media/CF.38f43b79.svg";